import script from "./CompanyLogo.vue?vue&type=script&setup=true&lang=js"
export * from "./CompanyLogo.vue?vue&type=script&setup=true&lang=js"

import "./CompanyLogo.vue?vue&type=style&index=0&id=0922a9d0&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/ignis-pha-production/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0922a9d0"]])

export default __exports__